import React from "react"
import styled from "@emotion/styled"
import { deviceMinW } from "../../../styles/mediaQueries"
import Img from "gatsby-image"

const ImagesRight = ({ image }) => {
    return (
        <>
            {image.columns === "2" && (
                <ImagesTwoColumns
                    fluid={image.src.childImageSharp.fluid}
                    alt={image.alt}
                    imgStyle={{
                        objectFit: "contain",
                        objectPosition: "top center"
                    }}
                />
            )}
            {image.columns === "1" && (
                <ImagesOneColumn
                    fluid={image.src.childImageSharp.fluid}
                    alt={image.alt}
                />
            )}
        </>
    )
}
export default ImagesRight

const ImagesOneColumn = styled(Img)`
    width: 100%;
    margin-bottom: 3%;
`

const ImagesTwoColumns = styled(Img)`
    width: 100%;
    margin-bottom: 3%;
    object-fit: contain;
    object-position: top center;

    @media ${deviceMinW.tablet} {
        width: 48%;
    }
`
